import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAlert } from 'react-alert'

import { OpinionModel, CustomerModel } from '../../../domain/models'
import {
  fetchCustomer,
  fetchOpinion,
  resetOpinion,
  saveOpinion,
  updateOpinion
} from '../../../main/usecases'

import { maskCpf, formatDate } from '../../utils'
import { useModalBox, useOnChangeDetect } from '../../contexts'
import {
  Button,
  EditorCard,
  ResetModal,
  ServicesHeader,
  SubHeader
} from '../../components'

import {
  IconSaveSvg,
  IconReturnSvg,
  PrinterSvg
} from '../../assets/icons/svgComponents'

import * as S from './styles'

const Opinion = ({ match }: any) => {
  const [customer, setCustomer] = useState<CustomerModel>()
  const [opinion, setOpinion] = useState<OpinionModel>()
  const [opinionData, setOpinionData] = useState('')
  const [loading, setLoading] = useState(false)
  const alert = useAlert()
  const { refresh, setRefresh } = useOnChangeDetect()
  const { modalBox } = useModalBox()
  const [resetLoading, setResetLoading] = useState(false)
  const handlePrinter = async () => {
    const body = {
      ...(opinion?.cdParecer && {
        cdParecer: opinion?.cdParecer
      }),
      parecer: opinionData
    }

    try {
      if (opinion?.cdParecer) {
        await updateOpinion({
          id: match?.params?.idassessment
        }).update(body)
        document
          ?.querySelectorAll('[style="display: block !important;"]')[0]
          ?.setAttribute('style', 'display:none !important;')
        window.print()
        setRefresh((prev: any) => !prev)
      } else {
        await saveOpinion({
          id: match?.params?.idassessment
        }).post(body)
        document
          ?.querySelectorAll('[style="display: block !important;"]')[0]
          ?.setAttribute('style', 'display:none !important;')
        window.print()
        setRefresh((prev: any) => !prev)
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    window.onafterprint = function () {
      document
        .querySelectorAll('[style="display:none !important;"]')[0]
        .setAttribute('style', 'display: block !important;')
    }
  }, [])

  useEffect(() => {
    ;(async () => {
      try {
        const responseCustomer = await fetchCustomer({
          id: match?.params?.id
        }).load()
        const responseOpinion = await fetchOpinion({
          id: match?.params?.idassessment
        }).load()
        setCustomer(responseCustomer)
        setOpinion(responseOpinion)
        setOpinionData(responseOpinion?.parecer)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [match.params.id, match?.params?.idassessment, refresh])

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    const body = {
      ...(opinion?.cdParecer && {
        cdParecer: opinion?.cdParecer
      }),
      parecer: opinionData
    }

    try {
      setLoading(true)
      if (opinion?.cdParecer) {
        await updateOpinion({
          id: match?.params?.idassessment
        }).update(body)
        alert.show('Atualizado com sucesso!', {
          type: 'success',
          timeout: 4000
        })
        setRefresh((prev: any) => !prev)
      } else {
        await saveOpinion({
          id: match?.params?.idassessment
        }).post(body)
        alert.show('Salvo com sucesso!', {
          type: 'success',
          timeout: 4000
        })
        setRefresh((prev: any) => !prev)
      }
    } catch (error) {
      console.error(error)
      alert.show('Error ao salvar/atualizar o Parecer', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setTimeout(() => {
        setLoading(false)
      }, 1500)
    }
  }

  const handleOpenResetModal = () => {
    modalBox(
      <ResetModal
        id={match?.params?.idassessment}
        loading={resetLoading}
        resetDocument={resetOpinion}
        setDocument={setOpinion}
        setDocumentData={setOpinionData}
        document="atestado"
      />,
      'Resetar Parecer',
      '32%'
    )
  }
  const onSaveReport = async () => {
    const body = {
      ...(opinion?.cdParecer && {
        cdRelatorio: opinion?.cdParecer
      }),
      relatorio: opinionData
    }

    try {
      setResetLoading(true)
      if (opinion?.cdParecer) {
        await updateOpinion({
          id: match?.params?.idassessment
        }).update(body)
        setRefresh((prev: any) => !prev)
      } else {
        await saveOpinion({
          id: match?.params?.idassessment
        }).post(body)
        setRefresh((prev: any) => !prev)
      }
      setResetLoading(false)
    } catch (error) {
      console.error(error)
    }
  }
  return (
    <S.Wrapper>
      {customer && (
        <SubHeader
          name={customer.nome}
          cpf={maskCpf(customer.cpf)}
          page="Voltar"
          link={`/meus-pacientes/${match.params.id}/prontuario?serviceId=${match.params.idservico}`}
        />
      )}
      <S.CardContainer>
        <ServicesHeader
          onClick={onSubmit}
          title="Parecer"
          hasPrinter
          disabled={loading}
          onPrinter={handlePrinter}
        />
        <EditorCard
          docType="parecer"
          data={opinion && opinion?.parecer}
          setData={setOpinionData}
          title=""
          height="auto"
          hasReset
          openResetModal={() => {
            onSaveReport()
            handleOpenResetModal()
          }}
        />
        <S.ButtonsContainer className="no-print">
          <Button
            initialIcon={<IconSaveSvg />}
            className="button-save"
            disabled={loading}
            onClick={onSubmit}
          >
            Salvar
          </Button>
          <Button
            initialIcon={<PrinterSvg />}
            className="button-printer"
            onClick={handlePrinter}
          >
            Imprimir
          </Button>
          <Button
            initialIcon={<IconReturnSvg />}
            hasSecodaryButton
            className="button-return-to-list"
          >
            <Link to={`/meus-pacientes/${match?.params?.id}/prontuario`}>
              Retornar à listagem
            </Link>
          </Button>

          {opinion?.dataUltimaModificacao && (
            <p>
              Data da última atualização:{' '}
              {formatDate(opinion?.dataUltimaModificacao || '')}
            </p>
          )}
        </S.ButtonsContainer>
      </S.CardContainer>
    </S.Wrapper>
  )
}
export default Opinion
